class RadioPharmacyApi {
    checkStatus(response) {
        switch (response.status) {
            case 200:
            case 204:
            case 210:
                //console.log('Conexión corecta', response.status);
                break;
            default:
                throw new Error(`${response.status} - ${response.statusText}!`);

        }
    }

    //Lista las Citas que tengan Radio Farmacia
    async listAppointmentRadioPharmacy() {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}radiofarmacia/listar-citas`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                this.checkStatus(response);
                return response.json();
            })
            .then(data => {
                datos = data;
            })
            .catch((error) => {
                datos = { "existe": false, "contenido": error.toString() };
            });
        return datos;
    }
}

export default new RadioPharmacyApi();